import { FieldValues, UseFormReturn } from "react-hook-form";
import { useEffect, useState } from "react";

const NO_EXCLUDED_FIELDS: string[] = [];

export function useFilterCount<T extends FieldValues>(
  form: UseFormReturn<T, any, FieldValues>,
  defaultFilters?: Partial<T>,
  excludeFields: string[] = NO_EXCLUDED_FIELDS,
) {
  const [activeFilterCount, setActiveFilterCount] = useState(0);

  useEffect(() => {
    const countFilters = (formValues: Partial<T>) => {
      if (Object.keys(form.formState.errors).length === 0) {
        const filtersCount = Object.keys(formValues).reduce((acc, key) => {
          if (
            excludeFields.includes(key) ||
            (defaultFilters && key in defaultFilters)
          ) {
            return acc;
          }
          const value = formValues[key as keyof typeof formValues];

          if (Array.isArray(value)) {
            acc += value.length;
          } else if (typeof value === "string") {
            if (value.trim().length > 0) {
              acc += 1;
            }
          } else if (value != null) {
            acc += 1;
          }

          return acc;
        }, 0);

        setActiveFilterCount(filtersCount);
      }
    };

    countFilters(form.getValues());
    const subscription = form.watch((formValues) =>
      countFilters(formValues as Partial<T>),
    );

    return () => subscription.unsubscribe();
  }, [form, defaultFilters, excludeFields]);

  return activeFilterCount;
}
